export default __webpack_public_path__ + "static/media/04_tag_indoor-pool.cf878a1e.svg";